export const CREATE = 'CREATE'
export const UPDATE = 'UPDATE'
export const DELETE = 'DELETE'
export const FETCH_ALL = 'FETCH_ALL'
export const FETCH_POST = 'FETCH_POST'
export const FETCH_BY_SEARCH = 'FETCH_BY_SEARCH'
export const LIKE = 'LIKE'

export const FAVORITE = 'FAVORITE'
export const GET_FAVORITE = 'GET_FAVORITE'
export const GET_USER_POSTS = "GET_USER_POSTS"
export const FOLLOWING = "FOLLOWING"
export const GET_FOLLOWING = "GET_FOLLOWING"
export const GET_USER_PROFILE = "GET_USER_PROFILE"
export const GET_USER_LIKED_POSTS = "GET_USER_LIKED_POSTS"
export const FETCH_USERS_BY_SEARCH = "FETCH_USERS_BY_SEARCH"


export const START_LOADING = 'START_LOADING'
export const END_LOADING = 'END_LOADING'

export const AUTH = 'AUTH'
export const CHECKUSER = "CHECKUSER"
export const LOGOUT = 'LOGOUT'


